module.exports = __webpack_public_path__ + "img/analytics-cmbs-intel-surveillance.75d5af08.png";